import { render, staticRenderFns } from "./QuizUploader.vue?vue&type=template&id=ac6d0fb6&scoped=true&"
import script from "./QuizUploader.vue?vue&type=script&lang=js&"
export * from "./QuizUploader.vue?vue&type=script&lang=js&"
import style0 from "./QuizUploader.vue?vue&type=style&index=0&id=ac6d0fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6d0fb6",
  null
  
)

export default component.exports